var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClinicGroups = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "30px",
    viewBox: "0 0 44 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Clinic Groups") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.478,26.31 L41.478,12.92 C41.4768964,12.0658444 40.7841564,11.3739993 39.93,11.374 L31.315,11.374 L31.315,26.802 L30.231,26.802 L30.231,1.547 C30.230448,0.692453758 29.5375464,0 28.683,0 L15.167,0 C14.3126155,0 13.62,0.692615492 13.62,1.547 L13.62,26.801 L12.536,26.801 L12.536,11.374 L4.127,11.374 C3.27300586,11.3739998 2.58055203,12.066006 2.58,12.92 L2.58,26.801 L0,26.801 L0,30.001 L43.851,30.001 L43.851,26.801 L41.478,26.801 L41.478,26.31 Z M5,22.618 L5,20.4 L7.222,20.4 L7.222,22.618 L5,22.618 Z M7.218,18.852 L5,18.852 L5,16.634 L7.222,16.634 L7.222,18.852 L7.218,18.852 Z M10.675,22.618 L8.461,22.618 L8.461,20.4 L10.679,20.4 L10.675,22.618 Z M10.675,18.852 L8.461,18.852 L8.461,16.634 L10.679,16.634 L10.675,18.852 Z M25.365,26.697 L18.856,26.697 L18.856,19.964 C18.8571034,19.1960008 19.48,18.574 20.248,18.574 L23.977,18.574 C24.7457804,18.574 25.369,19.1972196 25.369,19.966 L25.369,26.7 L25.365,26.697 Z M21.925,10.792 C19.3623988,10.792 17.285,8.71460124 17.285,6.152 C17.285,3.58939876 19.3623988,1.512 21.925,1.512 C24.4876012,1.512 26.565,3.58939876 26.565,6.152 C26.565,8.71460124 24.4876012,10.792 21.925,10.792 Z M36.009,22.618 L33.791,22.618 L33.791,20.4 L36.009,20.4 L36.009,22.618 Z M36.009,18.852 L33.791,18.852 L33.791,16.634 L36.009,16.634 L36.009,18.852 Z M39.465,22.618 L37.248,22.618 L37.248,20.4 L39.466,20.4 L39.465,22.618 Z M39.465,18.852 L37.248,18.852 L37.248,16.634 L39.466,16.634 L39.465,18.852 Z M23.02,5.057 L24.709,5.057 L24.709,7.246 L23.02,7.246 L23.02,8.936 L20.831,8.936 L20.831,7.246 L19.141,7.246 L19.141,5.057 L20.83,5.057 L20.83,3.368 L23.02,3.368 L23.02,5.057 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clinic-Groups",
    fill: "#2884FF",
    xlinkHref: "#path-1"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClinicGroups);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clinic_groups.e28b279830d141c7f5567f84b90433e2.svg";